import VoucherEntryFormView from '../../../components/account/create/voucher_entry/VoucherEntryFormView';

const VoucherEntryCreateListView = () => {
  return (
    <VoucherEntryFormView />
  )
}

export default VoucherEntryCreateListView